import { withEventContext } from "@codat/analytics";
import useQueryParams from "hooks/useQueryParams";
import { usePageViewedEvent } from "utils";

import CardContainer from "components/CardContainer";
import ErrorCard from "components/ErrorCard";

function NoMatchContent() {
  const queryParams = useQueryParams();
  const correlationId = queryParams.get("x-correlation-id");

  usePageViewedEvent({
    ready: true,
  });

  return (
    <CardContainer>
      <ErrorCard errorCode={404} correlationId={correlationId} />
    </CardContainer>
  );
}

export const NoMatch = withEventContext(NoMatchContent, "No match page");
